import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import styles from "../style/scanpack";
import I18n from "i18n-js";
const AddBarcodeButton = ({ addBarcodeFun, width }) => {
  return (
    <View style={styles.addBarcodeContainer}>
      <TouchableOpacity
        testID="AddBarcode"
        style={[
          styles.addBarcodeButton,
          width < 900 && {width: 'fit-content',paddingHorizontal: 8, marginLeft : 'auto', marginRight: 'auto'}
        ]}
        onPress={addBarcodeFun}
      >
        <Text
          style={styles.scanAddBarcodeText}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {I18n.t("nextItems.addBarCodeLabel")}
        </Text>
      </TouchableOpacity>
    </View>
  );
};
export default AddBarcodeButton;
